export default {
    root: {
        class: [
            "w-full",
            "flex flex-col",
            // "gap-2",
            "px-3 py-3",

            //Shape
            "lg:rounded-lg",
            // "lg:shadow",

            //Color
            "bg-white dark:bg-stone-900",
            "text-stone-700 dark:text-stone-50 border--y md:border-none",
        ],
    },
    body: {
        class: ["flex flex-col", "gap--2", "grow"],
    },
    title: {
        class: "text-lg font-bold",
    },
    subtitle: {
        class: [
            //Font
            "font-normal",

            //Spacing
            // "mb-2",

            //Color
            "text-stone-600 dark:text-stone-50/60",
        ],
    },
    content: {
        class: [
            "flex flex-col grow",
            // "py-5", // Vertical padding.
        ],
    },
    footer: {
        class: [
            // "pt-5", // Top padding.
        ],
    },
};
